import styled from 'styled-components';

export const StyledSingleEmail = styled.section`
  ${({ theme }) => theme.mixins.views}
`;
